import ImportCSV from "./ImportCSV";
import ImportVCard from "./ImportVCard";

export { ImportFactory as default };

/**
* Parse Factory
*
* Create instance to parse information from contact
*
* @author      brunorbarroso <bruno-b-rodrigues@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ImportFactory {

  /**
   * Factory Config to create a correct instance
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  static factory = {
    "text/csv": (content) => {
      return new ImportCSV(content)
    },
    "text/vcard": (content) => {
      return new ImportVCard(content)
    },

    "text/x-vcard": (content) => {
      return new ImportVCard(content)
    },

    "application/vnd.ms-excel": (content) => {
      return new ImportCSV(content)
    }
  }

  /**
   *
   * @param {string} content
   * @param {string} mime_type
   *
   * @returns {Object.ImportCSV|Object.ImportVCard}
   */
  static create(content, mime_type) {
    if(!this.factory[mime_type]){
      throw new Error('Mime type not mapped in factory class', {detail: `${mime_type} not is in factory list available`})
    }

    return this.factory[mime_type](content);
  }
}